<template>
    <Search :has-input="true" placeholder="请输入关键词" class="question-search" @searchChange="searchChange" @inputChange="searchChange">
        <Select :initValue="selectValue" :options="options" class="search-select" slot="right" @menuClick="typeChange" :topOrBottom="40" />
    </Search>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search.vue";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "CombinedSearch",
    components: { Search, Select },
    props: ["value", "widget", "verifyInfo", "validation"],
    data() {
        return {
            selectValue: this.value ? this.value.type : this.widget.props.options[0].value
        };
    },
    computed: {
        options() {
            return this.widget.props.options;
        },
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            const searchData = { type: this.selectValue, keyWord: data[0].value };
            this.$emit("change", searchData);
        }, 500);
    },
    methods: {
        typeChange(data) {
            this.selectValue = data.value;
        },
        searchChange(data) {
            this.searchHanlder(data);
        }
    }
};
</script>

<style scoped lang="less">
.search-select {
    border: 0;
    border-right: 1px solid #e3e3e3;
    border-radius: 0;
}
</style>
